const state = {
    forceRefresh: false,
    storeDesigner: false,
    debugMode: false,
    activeFilterTags: [],
    searchExpandedLock: false,
    allergenFilters: [],
    dietFilters: []
};

const getters = {
    forceRefresh(state) {
        return state.forceRefresh;
    },

    activeFilterTags(state) {
        return state.activeFilterTags;
    },
    searchExpandedLock(state) {
        return state.searchExpandedLock;
    },
    isStoreDesigner(state) {
        return state.storeDesigner;
    },
    isDebugMode(state) {
        return state.debugMode;
    },
    allergenFilters(state) {
        return state.allergenFilters;
    },
    dietFilters(state) {
        return state.dietFilters;
    }
};
const mutations = {
    setForceRefresh(state, bool) {
        state.forceRefresh = bool;
    },

    SET_STORE_DESIGNER(state, bool) {
        state.storeDesigner = bool;
    },
    SET_DEBUG_MODE(state, bool) {
        state.debugMode = bool;
    },
    toggleActiveFilterTags(state, value) {
        if (value === null) {
            state.activeFilterTags = [];

            return;
        }

        const index = state.activeFilterTags.indexOf(value);

        if (index === -1) {
            state.searchExpandedLock = true;
            state.activeFilterTags.push(value);
        } else {
            if (state.activeFilterTags.length === 1) {
                state.searchExpandedLock = false;
            }

            state.activeFilterTags.splice(index, 1);
        }
    },
    setAllergenFilters(state, filters) {
        state.allergenFilters = filters ? [...filters] : [];
    },
    setDietFilters(state, filters) {
        state.dietFilters = filters ? [...filters] : [];
    }
};
const actions = {
    setForceRefresh({ commit }, bool) {
        commit('setForceRefresh', bool);
    },
    setActiveFilterTags({ commit }, value) {
        commit('toggleActiveFilterTags', value);
    },
    setAllergenFilters({ commit }, filters) {
        commit('setAllergenFilters', filters);
    },
    setDietFilters({ commit }, filters) {
        commit('setDietFilters', filters);
    },
    enableStoreDesigner({ commit }) {
        window.storeDesigner = true;

        commit('SET_STORE_DESIGNER', true);
    },
    enableDebugMode({ commit }) {
        commit('SET_DEBUG_MODE', true);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
